import { Component, Input, Output, HostListener, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { UtilService } from '@app/shared/services/utils/util.service';
import { BasicButtonColors, BasicButtonModes, BasicButtonSizes } from '@app/shared/enums/buttons';

@Component({
  selector: 'cm-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent {
  @ViewChild('sideNavContainer')
  sideNavContainerRef: ElementRef<HTMLDivElement>;
  @ViewChild('sideNavContent') sideNavContentRef: ElementRef<HTMLDivElement>;
  @ViewChild('sideNavShadow') sideNavShadowRef: ElementRef<HTMLDivElement>;

  @Input() from = 'left';
  @Input() public options: { panelClass: string; closeButton: boolean };
  @Output() closeEmitter = new EventEmitter<any>();

  public mobile = false;
  public flag = false;
  public BasicButtonColors = BasicButtonColors;
  public BasicButtonModes = BasicButtonModes;
  public BasicButtonSizes = BasicButtonSizes;

  constructor() {
    this.options = { panelClass: '', closeButton: true };
    this.onResize();
  }

  get sideNavContainerStyle(): CSSStyleDeclaration {
    return this.sideNavContainerRef.nativeElement.style;
  }

  get sideNavContentStyle(): CSSStyleDeclaration {
    return this.sideNavContentRef.nativeElement.style;
  }

  get sideNavShadowStyle(): CSSStyleDeclaration {
    return this.sideNavShadowRef.nativeElement.style;
  }

  @HostListener('window:resize', ['$event']) onResize(): void {
    this.mobile = UtilService.isMobileAndTabletSize();
  }

  open(): void {
    this.sideNavContainerStyle.display = 'block';
    this.sideNavShadowStyle.display = 'block';
    setTimeout(() => {
      this.sideNavShadowStyle.opacity = '1';
      this.sideNavContentStyle[this.from] = '0';
    }, 100);
  }

  close(): void {
    this.sideNavShadowStyle.opacity = '0';
    this.sideNavContentStyle[this.from] = '-100%';
    setTimeout(() => {
      this.sideNavContainerStyle.display = 'none';
      this.sideNavShadowStyle.display = 'none';
    }, 500);
    this.closeEmitter.emit();
  }
}
